var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-card",class:_vm.variant},[_c('div',{staticClass:"stats-content"},[_c('span',{staticClass:"stats-label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"stats-value"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }